// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__Ss5vP"};